import { createApp } from "vue";
import { i18n } from "./i18n";
import App from "./App.vue";
import { createPinia } from "pinia";
import { fetchCat, fetchMonth, searchPosts } from "@/fetch";
import { type OrderByType, useItemStore } from "@/stores/items";
import { parseHashPath } from "@/helpers";

document
  .querySelectorAll("div.balticsea-archive")
  .forEach((element: Element) => {
    const htmlElement = element as HTMLElement;
    const type = htmlElement.dataset.type;
    if (type != undefined) {
      const lang = document.documentElement.lang.split("_")[0];

      i18n.global.locale = lang as "fi" | "sv" | "en";

      const app = createApp(App);

      app.use(createPinia());
      app.use(i18n);

      const itemStore = useItemStore();

      itemStore.taxonomy.primary = htmlElement.dataset.primary ?? "";
      itemStore.taxonomy.secondary = htmlElement.dataset.secondary ?? "";

      itemStore.type = type;
      itemStore.lang = lang;
      itemStore.showDate =
        htmlElement.dataset.date === "1" && type !== "hankkeet";
      itemStore.showSort = htmlElement.dataset.sort === "1";
      itemStore.showMonth = htmlElement.dataset.month === "1";
      if (itemStore.showDate) {
        itemStore.sort = false;
        itemStore.asc = false;
      } else {
        itemStore.sort = true;
        itemStore.asc = true;
      }
      itemStore.sort = !itemStore.showDate;
      itemStore.title = htmlElement.dataset.title ?? "primary";
      itemStore.tag = htmlElement.dataset.tag ?? "secondary";
      itemStore.mustHave = htmlElement.dataset.musthave ?? "";
      itemStore.sortType =
        (htmlElement.dataset.orderby as OrderByType) ?? "post_title";
      if (itemStore.sortType === "post_date") {
        itemStore.asc = false;
      }
      if (itemStore.sortType === "menu_order") {
        itemStore.sort = false;
      }
      itemStore.sortButtonText = htmlElement.dataset.sorttext ?? "ABC";

      if (window.location.hash) {
        parseHashPath(window.location.hash);
      }
      window.addEventListener(
        "hashchange",
        () => {
          if (itemStore.historyInhibit) {
            itemStore.historyInhibit = false;
          } else {
            console.log("The hash has changed!");
            // TODO: Figure out why this is not working.
            //parseHashPath(window.location.hash);
          }
        },
        false,
      );

      searchPosts();

      if (itemStore.taxonomy.primary) {
        fetchCat(itemStore.taxonomy.primary);
      }
      if (itemStore.taxonomy.secondary) {
        fetchCat(itemStore.taxonomy.secondary);
      }

      if (itemStore.showMonth) {
        fetchMonth();
      }

      app.mount(element);
    }
  });
